import React from 'react';

import {
  useEditInvestmentAreaModalLazyQuery,
  useSaveInvestmentAreaMutation
} from 'generated/graphql';
import {
  formUtil,
  useLoading,
  validationUtil
} from 'modules';
import * as yup from 'yup';



const __formSchema = yup.object({
  displayName: validationUtil.nonEmptyStringSchema.required('Display name is required.')
}).required();

export type IFormData = yup.InferType<typeof __formSchema>;



export function useQuery(investmentAreaId?: string) {
  const [fnRunQuery, tuple] = useEditInvestmentAreaModalLazyQuery();
  const [saveInvestmentArea, saveInvestmentAreaTuple] = __useSaveInvestmentAreaMutation(investmentAreaId);
  const loading = useLoading([tuple, saveInvestmentAreaTuple]);


  React.useEffect(() => {
    if (investmentAreaId) {
      fnRunQuery({ variables: { investmentAreaId } });
    }
  }, [fnRunQuery, investmentAreaId]);



  const form = formUtil.useRemoteData2FormState_experimental({
    schema: __formSchema,
    tuple: tuple as any,
    fnGqlData2FormState: (data: any) => ({
      displayName: data?.investmentArea?.displayName ?? ''
    })
  });



  return {
    ...tuple,
    loading,
    form,
    mutations: { saveInvestmentArea }
  };
}



function __useSaveInvestmentAreaMutation(investmentAreaId?: string) {
  const [fnMutate, tuple] = useSaveInvestmentAreaMutation();

  async function fnWrappedMutate(formData: IFormData) {
    await fnMutate({
      variables: {
        input: {
          id: investmentAreaId,
          displayName: formData.displayName
        }
      }
    });
  }

  return [
    fnWrappedMutate,
    {
      ...tuple,
      data: null
    }
  ] as const;
}
